import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { PremiumRequest, PremiumResponse } from '../productService/ProductServiceClient';
import { Policy } from './Policy';

export interface UwPolicyRateResult {
  response: PremiumResponse;
  rate: string;
}

// debug for cient true
@supertypeClass({ toClient: true, toServer: true })
export class UwPolicyRate extends Everything {
  @property()
  base: number;

  @property()
  waiver: number;

  @property()
  product: string;

  @property()
  state: string;

  @property()
  gender: string;

  @property()
  rateClass: string;

  @property()
  dob: Date;

  @property()
  face: number;

  @property()
  paymentFrequency: string;

  @property()
  productType: string;

  @property()
  term: number;

  @property({ getType: () => Policy })
  policy: Policy;

  constructor() {
    super();
  }

  static new(policy: Policy, request: PremiumRequest, response: PremiumResponse, rateClass: string) {
    return new UwPolicyRate().init(policy, request, response, rateClass);
  }

  init(policy: Policy, request: PremiumRequest, response: PremiumResponse, rateClass: string) {
    this.policy = policy;

    this.gender = request.gender;
    this.product = request.product;
    this.state = request.state;
    this.term = request.term;
    this.dob = request.dob;
    this.face = request.face;
    this.paymentFrequency = request.paymentFrequency;

    this.base = response.base;
    this.waiver = response.waiver;

    this.rateClass = rateClass;
    return this;
  }
}
